import Seo from "@/components/Seo";
import { FadeUp } from "@/components/Reveal";
import { BUSINESS } from "@/content/siteContent";

const SECTIONS = [
  { title: "Estimates & quotes", body: "Quotes submitted through this website are requests for estimates, not binding contracts. Final pricing is confirmed in writing before any work begins and may be adjusted if the actual scope differs from the information or media provided." },
  { title: "Accuracy of information", body: "You agree to provide accurate contact and project details, and to upload only photos and videos that belong to you and accurately represent the job. Do not upload unlawful, offensive, or third-party copyrighted content." },
  { title: "Scheduling & cancellation", body: "Confirmed appointments may be rescheduled or cancelled by contacting us directly. We ask for as much notice as possible so we can reassign our crews." },
  { title: "Service limitations", body: "Certain items (hazardous materials, illegal goods, and similar) cannot be transported or disposed of by our crews. We will always tell you upfront if something falls outside what we can handle." },
  { title: "Liability", body: "We treat your property with care and carry appropriate insurance. Any claims related to services performed are governed by the written service agreement provided at booking." },
  { title: "Website content", body: "All content on this site — text, design, and branding — belongs to Home Team Moving Co. and may not be reproduced without permission." },
];

export default function Terms() {
  return (
    <>
      <Seo
        title="Terms of Service | Home Team Moving Co."
        siteName="Home Team Moving Co."
        description="Terms governing use of the Home Team Moving Co. website and quote request services."
      />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:py-24">
        <FadeUp>
          <p className="eyebrow mb-4">Legal</p>
          <h1 className="font-display text-4xl font-extrabold uppercase tracking-tight text-white sm:text-5xl">Terms of Service</h1>
          <p className="mt-4 text-sm text-slate-400">Last updated: July 2026</p>
          <p className="mt-6 leading-relaxed text-slate-300">
            By using this website, you agree to the terms below. They cover use of the site and quote requests; services themselves are governed by the written agreement provided at booking.
          </p>
        </FadeUp>
        <div className="mt-12 space-y-10">
          {SECTIONS.map((s, i) => (
            <FadeUp key={s.title} delay={i * 0.05}>
              <h2 className="font-display text-xl font-bold uppercase tracking-wide text-gold">{s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-slate-300">{s.body}</p>
            </FadeUp>
          ))}
        </div>
        <FadeUp className="mt-12 border-t border-white/10 pt-8 text-sm text-slate-400">
          Questions about these terms? Email <a href={BUSINESS.emailHref} className="text-gold">{BUSINESS.email}</a>.
        </FadeUp>
      </section>
    </>
  );
}
